<template>
    <Loading
        :is-loading="isLoading"
        :text="processingText"
    />
    <PersonalInformation
        :visible="visible"
        :source="source"
        :token="tokenString"
        @clickBtn="agreePersonalInformation"
    />
</template>
<script>
import { reactive, toRefs } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { postSSOLogin, postPayAccSSOLogin } from '@/apis/login';
import { ssoInitExternalTransaction, ssoPayAccInitExternalTransaction } from '@/apis/system';
import Loading from '@/components/Loading.vue';
import routeName from '@/router/constant.js';
import aplCatlCode from '@/json/aplCatlCode';
import PersonalInformation from '@/components/dialogs/PersonalInformation.vue';
import { postNeedPersonalInformation } from '@/apis/agreeTerms';

export default {
    components: {
        Loading,
        PersonalInformation,
    },
    setup() {
        const route = useRoute();
        const router = useRouter();
        const store = useStore();
        const data = reactive({
            isLoading: true,
            processingText: '登入檢核中...',
            visible: false,
            tokenString: '',
            source: 'SSO',
            isPayAcc: false,
        });

        // 手機e方便或是SCV SSO 登入
        const ssoLogin = (data, isPayAccFlag) => {
            console.log('data.isPayAcc' + isPayAccFlag);
            if (isPayAccFlag) {
                return postPayAccSSOLogin(data).then((res) => {
                    store.dispatch('permissions/clearAll');
                    store.dispatch('permissions/setAuthExternal', 'Y');
                    store.dispatch('permissions/setUserInfo', res.data);
                    data.processingText = '處理中...';
                    return res.data.ssoToken;
                });
            }
            return postSSOLogin(data).then((res) => {
                store.dispatch('permissions/clearAll');
                store.dispatch('permissions/setAuthExternal', 'Y');
                store.dispatch('permissions/setUserInfo', res.data);
                data.processingText = '處理中...';
                return res.data.ssoToken;
            });
        };

        // 初始化交易，並轉導至指定頁面
        const initTransaction = (data, isPayAccFlag) => {
            if (isPayAccFlag) {
                return ssoPayAccInitExternalTransaction(data)
                    .then(res => res.data)
                    .then(data => {
                        // 設定vuex store
                        // 1. 初始化交易物件
                        console.log(data.transactionUniqueId);
                        store.dispatch('permissions/setAplCatl', data.aplCatl);
                        store.dispatch('permissions/setTransactionId', data.transactionUniqueId);
                        if (data.aplCatl === 'PAY_ACC') {
                            return {
                                routerName: data.routerName,
                                aplCatl: data.aplCatl,
                                params: data.params,
                            };
                        }
                        return {
                            routerName: data.routerName,
                            aplCatl: data.aplCatl,
                            params: data.params,
                        };
                    });
            }
            return ssoInitExternalTransaction(data)
                .then(res => res.data)
                .then(data => {
                    // 設定vuex store
                    // 1. 初始化交易物件
                    store.dispatch('permissions/setAplCatl', data.aplCatl);
                    store.dispatch('permissions/setTransactionId', data.transactionUniqueId);
                    if (data.aplCatl === aplCatlCode.A3) {
                        return {
                            routerName: data.routerName,
                            aplCatl: data.aplCatl,
                            params: data.params,
                        };
                    } else if (data.aplCatl === aplCatlCode.A4) {
                        return {
                            routerName: data.routerName,
                            aplCatl: data.aplCatl,
                            params: data.params,
                        };
                    } else if (data.aplCatl === aplCatlCode.A5) {
                        return {
                            routerName: data.routerName,
                            aplCatl: data.aplCatl,
                            params: data.params,
                        };
                    } else if (data.aplCatl === aplCatlCode.A6) {
                        return {
                            routerName: data.routerName,
                            aplCatl: data.aplCatl,
                            params: data.params,
                        };
                    } else if (data.aplCatl === 'PAY_ACC') {
                        return {
                            routerName: data.routerName,
                            aplCatl: data.aplCatl,
                            params: data.params,
                        };
                    }
                    return {
                        routerName: data.routerName,
                        aplCatl: data.aplCatl,
                        params: data.params,
                    };
                });
        };

        // GET url 當中的參數 param，就是 SSO token
        const token = {
            token: route.query.param,
        };
        data.tokenString = token.token;

        const agreePersonalInformation = () => {
            data.visible = false;
            console.log('initpayacc1' + data.isPayAcc);
            const isPayAcc = data.isPayAcc;
            // 開始登入
            ssoLogin(token, isPayAcc)
                .then(data => {
                    if (data.aplCatl) {
                        // 如果產生的 sso token 資訊當中有包含交易類型，就會開始初始化交易
                        return initTransaction(data, isPayAcc);
                    } else {
                        // 如果產生的 sso token 資訊當中沒有包含交易類型
                        return { routerName: routeName.HOME };
                    }
                })
                .then(result => {
                    const routerName = result?.routerName;

                    if (routerName) {
                        router.push({ name: routerName });
                    } else {
                        router.push({ name: routeName.HOME });
                    }
                })
                .catch((ex) => {
                    router.push({
                        name: routeName.FORBIDDEN,
                        params: { errorMessage: ex.data.errorMessage },
                    });
                })
                .finally(() => {
                    data.isLoading = false;
                });
        };

        const initCheck = () => {
            const request = {
                token: data.tokenString,
            };
            postNeedPersonalInformation(request).then((res) => {
                if (res.data.payAccFlag) {
                    data.isPayAcc = true;
                    console.log('initpayacc0' + data.isPayAcc);
                }
                if (res.data.needPersonalInformation) {
                    data.visible = true;
                } else {
                    agreePersonalInformation();
                }
            }).catch((ex) => {
                router.push({
                    name: routeName.FORBIDDEN,
                    params: { errorMessage: ex.data.errorMessage },
                });
            });
        };

        initCheck();

        return {
            ...toRefs(data),
            agreePersonalInformation,
        };
    },
};
</script>
